import { useQuery } from '@tanstack/react-query';
import { getViolationsConfiguration } from './getViolationsConfiguration';

import { ViolationConfigurationModel } from './types';
import { QUERY_KEY_SETTINGS_VIOLATION, SETTINGS_QUERY_NO_CACHE } from '@/lib/api/constants'

type Props = {
  companyId: string
}

export function useQueryViolationsConfiguration(props: Props) {
  const { companyId } = props
  return useQuery<ViolationConfigurationModel>({
    queryKey: [QUERY_KEY_SETTINGS_VIOLATION, companyId],
    queryFn: async () => {
      // if (COMPANY_API_SETTINGS_MOCKED) {
      //   return violationConfigurationMock
      // }
      // @TODO remove companyId from queryKey and endpoint when backend is fixed
      const { data } = await getViolationsConfiguration(props);
      return data;
    },
    ...SETTINGS_QUERY_NO_CACHE,
  });
}
